module.exports = __webpack_public_path__ + "static/img/shape-12@2x.29a15c02.png";